// extracted by mini-css-extract-plugin
module.exports = {"root":"CircularProgress_root__3afJq","svg":"CircularProgress_svg__Z9ENT","animation_circular_progress":"CircularProgress_animation_circular_progress__cb2kR"};